import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TypeListService = /** @class */ (function () {
    function TypeListService(http) {
        this.http = http;
    }
    TypeListService.prototype.getCitiesByPostalCode = function (postalCode, countryCode) {
        if (countryCode === void 0) { countryCode = 'ar'; }
        var baseUrl = environment.server.api.portalpasProxy;
        return this.http.get(baseUrl + "/policycenter-typelist/api/Locations/cities-by-postal-code?countryCode=" + countryCode + "&postalCode=" + postalCode);
    };
    TypeListService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TypeListService_Factory() { return new TypeListService(i0.ɵɵinject(i1.HttpClient)); }, token: TypeListService, providedIn: "root" });
    return TypeListService;
}());
export { TypeListService };
